import { band, bandAlt, bandHero } from "../../lib/ui.ts";

type Variant = "default" | "alt" | "hero";

export function Band({
  variant = "default",
  id,
  className,
  children,
}: {
  variant?: Variant;
  id?: string;
  className?: string;
  children: React.ReactNode;
}) {
  const base = variant === "hero" ? bandHero : variant === "alt" ? `${band} ${bandAlt}` : band;
  const classes = className ? `${base} ${className}` : base;
  return (
    <section id={id} className={classes}>
      {children}
    </section>
  );
}
